import { ExternalLink, BookOpen } from "lucide-react";

export const GmailPromotionsSources = () => {
  const sources = [
    {
      title: "Gmail Help: Categories and tabs",
      url: "https://support.google.com/mail/answer/3094499",
      description: "Official Google documentation on how Gmail categories work"
    },
    {
      title: "Google Postmaster Tools",
      url: "https://postmaster.google.com/",
      description: "Track sender reputation and spam rates with Gmail"
    },
    {
      title: "RFC 5322 - Internet Message Format",
      url: "https://datatracker.ietf.org/doc/html/rfc5322",
      description: "Official email format specification standards"
    },
    {
      title: "M3AAWG Best Practices",
      url: "https://www.m3aawg.org/published-documents",
      description: "Anti-abuse working group email best practices"
    },
    {
      title: "DMARC.org Resources",
      url: "https://dmarc.org/resources/",
      description: "Email authentication and DMARC implementation guides"
    },
    {
      title: "Email on Acid Deliverability Guide",
      url: "https://www.emailonacid.com/blog/article/email-deliverability/",
      description: "Technical email deliverability resources and testing"
    }
  ];

  return (
    <section className="py-8 sm:py-10">
      <div className="mb-6 sm:mb-8">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 rounded-xl bg-muted flex items-center justify-center">
            <BookOpen className="w-5 h-5 text-muted-foreground" />
          </div>
          <h2 className="font-display text-2xl sm:text-3xl font-bold text-foreground">
            Sources & Further Reading
          </h2>
        </div>
        <p className="text-muted-foreground">
          Verified sources used in this analysis
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {sources.map((source, index) => (
          <a
            key={index}
            href={source.url}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-card border border-border rounded-xl p-4 hover:border-primary/30 hover:bg-muted/30 transition-all group"
          >
            <div className="flex items-start justify-between gap-2 mb-2">
              <h3 className="font-semibold text-foreground text-sm group-hover:text-primary transition-colors">
                {source.title}
              </h3>
              <ExternalLink className="w-4 h-4 text-muted-foreground shrink-0 group-hover:text-primary transition-colors" />
            </div>
            <p className="text-xs text-muted-foreground">
              {source.description}
            </p>
          </a>
        ))}
      </div>
    </section>
  );
};
